var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CognitoUserPool, CognitoUserAttribute, CognitoRefreshToken, AuthenticationDetails, CognitoUser } from "amazon-cognito-identity-js";
import axios from "axios";
import { Constants } from "../../../../utils/Constants";
const clientId = Constants.REACT_APP_CLIENT_ID || "";
const userPoolId = Constants.REACT_APP_USER_POOL_ID || "";
const googlePassword = Constants.REACT_APP_GOOGLE_PASSWORD || "";
const poolData = {
    UserPoolId: userPoolId,
    ClientId: clientId,
};
const userPool = new CognitoUserPool(poolData);
// user login check
export const checkUserLogin = (username, password) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        if (username && password) {
            const authenticationDetails = new AuthenticationDetails({
                Username: username.toLocaleLowerCase(),
                Password: password,
            });
            const userData = {
                Username: username.toLocaleLowerCase(),
                Pool: userPool,
            };
            const cognitoUser = new CognitoUser(userData);
            cognitoUser.authenticateUser(authenticationDetails, {
                onSuccess: (session) => {
                    const accessToken = session.getAccessToken().getJwtToken();
                    const idToken = session.getIdToken().getJwtToken();
                    const refreshToken = session.getRefreshToken().getToken();
                    localStorage.setItem("accessToken", accessToken);
                    localStorage.setItem("idToken", idToken);
                    localStorage.setItem("refreshToken", refreshToken);
                    // Store tokens securely (e.g., in local storage) for future use
                    resolve({ accessToken, idToken, refreshToken });
                },
                onFailure: (err) => {
                    reject(err);
                },
                newPasswordRequired: (userAttributes, requiredAttributes) => {
                    // Handle the case where a new password is required (e.g., user must reset password)
                    reject({ newPasswordRequired: true });
                },
            });
        }
        else {
            reject(new Error("Email and Password are required"));
        }
    }));
});
// Function google sign up
export const signUpGoogle = (tokenResponse) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (tokenResponse && tokenResponse.access_token) {
                let userGoogleResponse = yield getGoogleUserData(tokenResponse).catch((error) => {
                    reject(error);
                    return;
                });
                if (userGoogleResponse) {
                    const userEmailID = userGoogleResponse.email;
                    // pre check if user already sign in
                    const userLoginResponsePreCheck = yield checkUserLogin(userEmailID, googlePassword).catch(() => { });
                    if (userLoginResponsePreCheck) {
                        resolve(userLoginResponsePreCheck);
                        return;
                    }
                    // If new user sign up using google cognito pool
                    const userPoolResponse = yield signUpCognito(userEmailID, googlePassword, "google").catch((error) => {
                        reject(error);
                        return;
                    });
                    if (userPoolResponse) {
                        // sign the user
                        const userLoginResponse = yield checkUserLogin(userEmailID, googlePassword).catch((error) => {
                            reject(error);
                            return;
                        });
                        resolve(userLoginResponse);
                    }
                }
            }
            else {
                reject(new Error("Invalid google login"));
            }
        }
        catch (error) {
            console.error("Error processing Google Sign-in response", error);
            reject(error);
        }
    }));
});
// send reset code
export const sentResetCode = (username) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        // setup cognitoUser first
        const userData = {
            Username: username,
            Pool: userPool,
        };
        const cognitoUser = new CognitoUser(userData);
        // call forgotPassword on cognitoUser
        cognitoUser.forgotPassword({
            onSuccess: function (result) {
                console.log("call result: " + result);
                resolve(result);
            },
            onFailure: function (err) {
                reject(err);
            },
        });
    }));
});
// change the password
export const resetPassword = (username, verificationCode, newPassword) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        const userData = {
            Username: username,
            Pool: userPool,
        };
        const cognitoUser = new CognitoUser(userData);
        if (cognitoUser) {
            cognitoUser.confirmPassword(verificationCode, newPassword, {
                onSuccess: function (result) {
                    console.log("Password confirmed!");
                    resolve(result);
                },
                onFailure: function (err) {
                    reject(err);
                },
            });
        }
        else {
            console.log("Invalid user emailId");
        }
    }));
});
// fetch user google login data
export const getGoogleUserData = (tokenResponse) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        const userInfo = yield axios
            .get("https://www.googleapis.com/oauth2/v3/userinfo", {
            headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        })
            .then((res) => resolve(res.data))
            .catch((error) => reject(error));
    }));
});
const generateUUIDv4 = () => {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) => (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16));
};
// sign up google user pool
export const signUpCognito = (userEmail, password, domain) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let attributeList = [];
            if (domain === "google") {
                const dataDomain = {
                    Name: "custom:domain",
                    Value: "google",
                };
                const attributeDomain = new CognitoUserAttribute(dataDomain);
                attributeList.push(attributeDomain);
                password = googlePassword;
            }
            const dataTenantId = {
                Name: "custom:tenant_id",
                Value: generateUUIDv4(),
            };
            const attributeTenantId = new CognitoUserAttribute(dataTenantId);
            attributeList.push(attributeTenantId);
            userPool.signUp(userEmail.toLocaleLowerCase(), password, attributeList, [], function (error, result) {
                if (error && error instanceof Error) {
                    reject(error);
                    return;
                }
                const cognitoUser = result.user;
                console.log("user name is " + cognitoUser.getUsername());
                resolve(result);
            });
        }
        catch (error) {
            console.error("Error user pool Sign-in response", error);
            reject(error);
        }
    }));
});
export const logout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("idToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("baseLocation");
    localStorage.removeItem("walletId");
    localStorage.removeItem("showBanner");
    localStorage.removeItem("rowsPerPage");
    Object.keys(localStorage).forEach(function (key) {
        if (key.startsWith("CognitoIdentityServiceProvider")) {
            localStorage.removeItem(key);
        }
    });
    const cognitoUser = userPool.getCurrentUser();
    if (cognitoUser) {
        cognitoUser.signOut();
        console.log("User signed out successfully");
    }
    else {
        console.log("No user to sign out");
    }
};
export const refreshToken = () => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        const cognitoUser = userPool.getCurrentUser();
        const refreshToken = localStorage.getItem("refreshToken");
        // const cognitoUserSession = await getSessionService();
        // const refreshToken = cognitoUserSession.getRefreshToken();
        if (cognitoUser && refreshToken) {
            // Create a CognitoRefreshToken object
            const cognitoRefreshToken = new CognitoRefreshToken({ RefreshToken: refreshToken });
            cognitoUser.refreshSession(cognitoRefreshToken, (error, newSession) => {
                if (error) {
                    console.error("Error refreshing session:", error);
                    logout();
                    window.location.pathname = "/login";
                    reject(error);
                }
                else {
                    console.log("Session refreshed successfully");
                    console.log(newSession);
                    const accessToken = newSession.getAccessToken().getJwtToken();
                    const idToken = newSession.getIdToken().getJwtToken();
                    const refreshToken = newSession.getRefreshToken().getToken();
                    localStorage.setItem("accessToken", accessToken);
                    localStorage.setItem("idToken", idToken);
                    localStorage.setItem("refreshToken", refreshToken);
                    // Use newAccessToken for further authenticated requests
                    resolve(accessToken);
                }
            });
        }
        else {
            logout();
            window.location.pathname = "/login";
        }
    }));
});
